import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { Animated } from "react-animated-css";
import './style.css';
import waterdrop from "../../assets/waterdrop-login.png"
import logo from "../../assets/ghidro-logo-footer.png"
import axios from 'axios'
import auth from '../../utils/auth';
import cfg from '../../utils/config';

class Login extends Component {

    state = {
        email: "",
        password: "",
        conexao_persistente: false,
        redirectToReferrer: false,
        showmessage: false,
        logomarca: logo,
        loadcomplete: false,
        config: { "titulo_sistema": "Hidroview v4", "descricao_sistema": "", "logomarca": "logomarcas/kronlogo.png", "descricao_horario_atendimento": "Seg. a Sex. das 8:00 às 18:00 ", "email_contato": "contato@ghidro.com.br ", "endereco": "Rua Carlos Ferrari, 18, Sala 610 – Centro – Garça/SP", "facebook": "https://www.facebook.com/ghidromonitoramento/", "link_criar_conta": "https://www.ghidro.com.br", "linkedin": "https://www.linkedin.com/company/g-hidro-monitoramento/", "telefone": "(14) 98161-0616", "youtube": "https://www.youtube.com/channel/UCj1BOaOQTuPMrTgPewSwgvw" },
        cores: { "degrade_top_primeira_cor": "#F44E3B", "degrade_top_segunda_cor": "#2f577b", "back_logomarca": "#37424A", "back_menu_lateral": "#37424A", "fonte_menu_lateral": "#c7c7c7", "fonte_grupo_menu_lateral": "#c7c7c7" }
    }

    componentWillMount = () => {
        let requestArray = []
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } };

        requestArray.push(axios.get(cfg.base_api_url + cfg.api_version + '/configuracao-login/?domain=' + window.location.hostname, config_me))

        axios.all(requestArray)
            .then(axios.spread((config) => {

                let cores = { "degrade_top_primeira_cor": "#F44E3B", "degrade_top_segunda_cor": "#2f577b", "back_logomarca": "#37424A", "back_menu_lateral": "#37424A", "fonte_menu_lateral": "#c7c7c7", "fonte_grupo_menu_lateral": "#c7c7c7" }
                let logomarca = ''
                let config_nova = ''

                if (config.status === 200) {
                    cores = config.data.cores
                }

                if (config.status === 200) {
                    logomarca = config.data.config.logomarca
                    config_nova = config.data.config
                }

                this.setState({ cores: cores, opacity: 1, logomarca: logomarca, loadcomplete: true, 'config': config_nova })

                if (config.status === 200) {
                    document.title = (config.data.config.titulo_sistema) ? (config.data.config.titulo_sistema) : "Hidroview v4"
                } else {
                    document.title = "Hidroview v4"
                }

            }));
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.handleSubmit(e)
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const requestURL = cfg.base_api_url + 'o/token/'
        const config = { headers: { 'Content-Type': 'application/json' } }

        var bodyFormData = new FormData();
        bodyFormData.append("client_id", cfg.client_id)
        bodyFormData.append("client_secret", cfg.client_secret)
        bodyFormData.append("grant_type", cfg.grant_type)
        bodyFormData.append("username", this.state.email)
        bodyFormData.append("password", this.state.password)

        axios.post(requestURL, bodyFormData, config)
            .then((response) => {
                auth.setToken(response.data.access_token, true)
                auth.set(response.data.refresh_token, '__hidroview__refresh_token', true)
                auth.set({ "checked": this.state.conexao_persistente }, '__hidroview__persist_connect', true)

                const config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } };

                axios.get(cfg.base_api_url + cfg.api_version + '/me/', config_me)
                    .then((response) => {
                        response.data['pai'] = response.data.empresa
                        auth.setUserInfo(response.data, true)
                        this.setState({ redirectToReferrer: true })
                    })

            })
            .catch((error) => {
                this.setState({ showmessage: true })
                setTimeout(() => {
                    this.setState({ showmessage: false })
                }, 5000);
            });
    }

    render() {
        const { from } = this.props.location.state || { from: { pathname: "/" } }
        const { redirectToReferrer } = this.state

        if (redirectToReferrer) {
            return <Redirect to={from} />
        }

        if (auth.getToken() !== null) {
            return <Redirect to={from} />
        }
        return (
            <div className={(this.state.loadcomplete) ? "body-page" : "hdv-noshow-item"} style={{ 'background': 'linear-gradient(to bottom, ' + this.state.cores.login_degrade_primeira_cor_background + ' 0%, ' + this.state.cores.login_degrade_primeira_cor_background + ' 56%, ' + this.state.cores.login_degrade_segunda_cor_background + ' 100%)' }}>
                <Animated className="mensagem-erro" animationIn="fadeInDown" animationOut="fadeOutDown" animateOnMount={false} isVisible={this.state.showmessage}>
                    <div>
                        Falha na autenticação, por favor verifique seus dados e tente novamente. <br />
                        <i className="fa fa-exclamation mensagem-icone fa-white"></i>
                    </div>
                </Animated>
                <div className="center-login" style={{ 'backgroundColor': this.state.cores.login_informacao_background }}>
                    <div className="gota hdv-noshow-item">
                        <img srcSet={waterdrop} alt="" />
                    </div>
                    <div className="logomarca">
                        <img width="200px" src={this.state.logomarca} alt="" />
                        <div className="subtitulo-logo" style={{ 'color': this.state.cores.login_informacao_fonte_cor }}>{this.state.config.descricao_sistema}</div>
                    </div>
                    <div className="rodape">
                        <div className="texto-rodape" style={{ 'color': this.state.cores.login_informacao_fonte_cor }}>
                            {this.state.config.endereco} <br />
                            {this.state.config.telefone} <br />
                            {this.state.config.email_contato} <br />
                            {this.state.config.descricao_horario_atendimento} <br />
                        </div>
                    </div>
                    <div className="sociais">
                        <a target="_blank" rel="noopener noreferrer" href={this.state.config.facebook}>
                            <i className="fa fa-facebook-f facebook-social fa-white"></i>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href={this.state.config.linkedin}>
                            <i className="fa fa-linkedin lkdn-social fa-white"></i>
                        </a>
                        <a target="_blank" rel="noopener noreferrer" href={this.state.config.youtube}>
                            <i className="fa fa-youtube tube-social fa-white"></i>
                        </a>
                    </div>
                    <div className="form-login" style={{ 'backgroundColor': this.state.cores.login_formulario_background }}>
                        <div style={{ 'color': this.state.cores.login_formulario_fonte_cor }} className="titulo">ACESSO A PLATAFORMA</div>
                        <form>
                            <label style={{ 'color': this.state.cores.login_formulario_fonte_cor }} className="labels">E-MAIL:</label>
                            <input type="text" id="email" onChange={e => this.setState({ email: e.target.value })} onKeyPress={this.handleKeyPress} className="campo-form" />
                            <label style={{ 'color': this.state.cores.login_formulario_fonte_cor }} className="labels">SENHA:</label>
                            <input type="password" id="password" onChange={e => this.setState({ password: e.target.value })} onKeyPress={this.handleKeyPress} className="usuario" />
                            <div>
                                <span className="permanecer-conectado">
                                    <input onChange={e => this.setState({ conexao_persistente: e.target.checked })} onKeyPress={this.handleKeyPress} type="checkbox" name="permanecer" id="permanecer" />
                                    <span style={{ 'color': this.state.cores.login_formulario_fonte_cor }} className="permancer-label">Permanecer conectado?</span>
                                </span>
                                <div className="btn-login" onClick={this.handleSubmit}>Acessar</div>
                            </div>
                        </form>
                        <div className="esqueci links" style={{ 'color': this.state.cores.login_formulario_fonte_link }}><Link className="alogin" to="/lost-password">Esqueci minha senha</Link></div>
                        <div className="criar-conta links" style={{ 'color': this.state.cores.login_formulario_fonte_link }}><a className="alogin" target="_blank" rel="noopener noreferrer" href={this.state.config.link_criar_conta}>Criar minha conta</a></div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Login;